import * as React from 'react';
import Cities from '@ui/scenes/Cities';

const CitiesPage = () => (
  <div className="cities-page">
    <Cities />
  </div>
);

export default CitiesPage;



// WEBPACK FOOTER //
// ./src/pages/Cities/Cities.tsx